import classNames from 'classnames'
import React from 'react'

import s from './SuggestItem.less'

import { suggestServiceCtx } from '../../store/suggest/suggest.service.constants'
import SVGIcon from '../svg/SVGIcon'

import { SUGGEST_CLICK } from '../analytics/analytics.tagids.constants'
import { POI_POSITION, POI_TYPE, ZIP } from '../analytics/ClickTagsService'
import TagActionButton from '../genericComponents/TagActionButton'

const BrandItemContent = props => {
  const { suggest = {} } = props
  const { labels, brandIconUrl } = suggest
  const [firstLabel] = labels
  return (
    <>
      {brandIconUrl && (
        <div className={s.brandLogo}>
          <img src={brandIconUrl} />
        </div>
      )}
      <div className={classNames(s.SuggestItem_text, s.oneLabel)}>
        <span className={s.SuggestItem_mainLabel} dangerouslySetInnerHTML={{ __html: firstLabel }} />
      </div>
    </>
  )
}

const GenericContent = props => {
  const { suggest } = props
  const [firstLabel, ...otherLabels] = suggest.labels
  const icon = suggest?.subtype?.id
  const iconUrls = suggest?.iconUrls ?? false

  return (
    <>
      <div className={classNames(s.icon, 'icon', s[icon])}>
        <SVGIcon icon={icon} ssrWhite />
      </div>
      <div className={classNames(s.SuggestItem_text, otherLabels.length === 0 && s.oneLabel)}>
        <span className={s.SuggestItem_mainLabel} dangerouslySetInnerHTML={{ __html: firstLabel }} />
        {iconUrls && (
          <span>
            {iconUrls.map((iconUrl, idx) => {
              return <img className={s.SuggestItem_icon} key={`${firstLabel}-${idx}`} src={iconUrl} />
            })}
          </span>
        )}
        {!iconUrls && (
          <span className={s.SuggestItem_secondaryLabel}>
            {otherLabels.map((label, id) => (
              <span key={id} dangerouslySetInnerHTML={{ __html: `${label} ` }} />
            ))}
          </span>
        )}
      </div>
    </>
  )
}

const EventContent = props => {
  const { suggest } = props
  const icon = suggest?.subtype?.id
  const { address_components } = suggest
  const postcode = address_components?.postcodes?.[0]
  const town = address_components?.town?.label
  const address = postcode && town ? `${postcode}, ${town}` : undefined
  const otherName = address_components?.other_name

  return (
    <>
      <div className={classNames(s.icon, 'icon', s[icon])}>
        <SVGIcon icon={icon} ssrWhite />
      </div>
      <div className={classNames(s.SuggestItem_text)}>
        <span
          className={classNames(s.SuggestItem_mainLabel, s.SuggestItem_eventLabel)}
          dangerouslySetInnerHTML={{ __html: suggest.labels[0] }}
        />
        {otherName && (
          <span className={classNames(s.SuggestItem_mainLabel, s.SuggestItem_eventLabel)}>{otherName}</span>
        )}
        {address && (
          <span className={classNames(s.SuggestItem_secondaryLabel, s.SuggestItem_eventLabel)}>
            <span>{address}</span>
          </span>
        )}
      </div>
    </>
  )
}

const SuggestItemContent = ({ type, suggest, isEventSuggest }) => {
  if (type === suggestServiceCtx.type.store_chain) {
    return <BrandItemContent suggest={suggest} />
  } else if (isEventSuggest) {
    return <EventContent suggest={suggest} />
  } else {
    return <GenericContent suggest={suggest} />
  }
}

const SuggestItem = props => {
  const { suggest, idx } = props

  const type = suggest?.type

  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    const { onClick, suggest } = props
    onClick && onClick(suggest)
  }

  const onMouseEnter = () => {
    const { idx, updateSelectedId } = props
    updateSelectedId(idx)
  }

  const onFocus = () => {
    const { idx, updateSelectedId } = props
    updateSelectedId(idx)
  }

  return (
    <TagActionButton
      type={SUGGEST_CLICK}
      tagInfo={{
        [POI_TYPE]: suggest?.subtype?.id,
        [POI_POSITION]: idx + 1,
        [ZIP]: suggest?.postcode,
      }}
      className={s.SuggestItem_link}
      {...{
        onClick,
        onMouseEnter,
        onFocus
      }}
    >
      <SuggestItemContent type={type} suggest={suggest} />
    </TagActionButton>
  )
}

export default SuggestItem
